import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { postData } from "../services/api.service";
import profileImage from "../assets/img/profile.PNG";
import Logo from "../assets/img/Logo.png";
import { Link } from "react-router-dom";
import "../styles/Form.css";
import { swalAlertDanger } from "../components/common/Alerts";

const Register = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();
  const navigate = useNavigate();
  const [serverError, setServerError] = useState("");
  const [acceptTerms, setAcceptTerms] = useState(false);

  const onSubmit = async (data) => {
    if (!acceptTerms) {
      swalAlertDanger(
        "Términos y Condiciones",
        "Debe aceptar los términos y condiciones para continuar",
        () => {}
      );
      return;
    }

    if (data.password !== data.confirmPassword) {
      setServerError("Las contraseñas no coinciden");
      return;
    }

    const { confirmPassword, ...payload } = data;
    try {
      const response = await postData("/api/register_client", payload);
      if (response.status === 200) {
        navigate("/login");
      } else {
        setServerError(response.data.msg || "Error al registrar el cliente");
      }
    } catch (error) {
      setServerError("Error en el servidor. Intente nuevamente.");
    }
  };

  return (
    <div className="register-container">
      <Link to="/">
        <img src={Logo} alt="logo" className="login-logo" />
      </Link>
      <div className="register-card">
        <div className="register-header">
          <h2>¡Bienvenido!</h2>
          <p>Llego la hora de crear tu cuenta.</p>
          <div className="avatar-circle">
            <img
              src={profileImage}
              alt="User Avatar"
              className="avatar-image"
            />
          </div>
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="register-form">
          <input
            placeholder="Nombre"
            {...register("first_name", {
              required: "El nombre es obligatorio",
            })}
            className="input-style"
          />
          <input
            placeholder="Apellido"
            {...register("last_name", {
              required: "El apellido es obligatorio",
            })}
            className="input-style"
          />
          <input
            placeholder="Correo electrónico (E-mail)"
            type="email"
            {...register("email", {
              required: "El correo electrónico es obligatorio",
              pattern: {
                value: /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/,
                message: "El correo electrónico no es válido",
              },
            })}
            className="input-style"
          />
          <input
            placeholder="Teléfono"
            type="tel"
            {...register("phone_number", {
              required: "El teléfono es obligatorio",
              pattern: {
                value: /^[0-9]+$/,
                message: "El teléfono debe contener solo números",
              },
            })}
            className="input-style"
          />
          <input
            placeholder="Contraseña"
            type="password"
            {...register("password", {
              required: "La contraseña es obligatoria",
              minLength: {
                value: 6,
                message: "La contraseña debe tener al menos 6 caracteres",
              },
            })}
            className="input-style"
          />

          {errors.password && (
            <p className="error-text">{errors.password.message}</p>
          )}

          <input
            placeholder="Confirmar contraseña"
            type="password"
            {...register("confirmPassword", {
              required: "Debe confirmar la contraseña",
              validate: (value) =>
                value === watch("password") || "Las contraseñas no coinciden",
            })}
            className="input-style"
          />

          {errors.confirmPassword && (
            <p className="error-text">{errors.confirmPassword.message}</p>
          )}

          <div className="terms-checkbox" style={{ 
            margin: "15px 0", 
            textAlign: "left",
            fontSize: "14px",
            color: "#333"
          }}>
            <label style={{ 
              display: "flex", 
              alignItems: "flex-start", 
              cursor: "pointer",
              lineHeight: "1.4"
            }}>
              <input
                type="checkbox"
                checked={acceptTerms}
                onChange={(e) => setAcceptTerms(e.target.checked)}
                style={{ 
                  marginRight: "8px", 
                  marginTop: "2px",
                  transform: "scale(1.2)"
                }}
                required
              />
              <span>
                Acepto los{" "}
                <Link 
                  to="/terms-and-conditions" 
                  style={{ 
                    color: "#E35E1E", 
                    textDecoration: "underline",
                    fontWeight: "bold"
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Términos y Condiciones
                </Link>
              </span>
            </label>
          </div>

          {serverError && <p className="error-text">{serverError}</p>}

          <button 
            type="submit" 
            className="submit-button"
            disabled={!acceptTerms}
            style={{
              opacity: !acceptTerms ? 0.6 : 1,
              cursor: !acceptTerms ? "not-allowed" : "pointer"
            }}
          >
            Registrarse
          </button>

          <p className="login-text">
            ¿Ya tienes cuenta?{" "}
            <span onClick={() => navigate("/login")}>
              ¡Iniciar sesión aquí!
            </span>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Register;
